const baseUrl = (process.env.NODE_ENV === 'development') ?
        `http://${window.location.hostname}:8081/sgm` :
        `http://${window.location.hostname}:8081/sgm`;

export default {
    createSessao: { method: 'post', url: `${baseUrl}/login` },
    sessao: { method: 'get', url: `${baseUrl}/sessao` },
    login: { method: 'get', url: `${baseUrl}/empresa` },
    resetPassword: { method: 'post', url: baseUrl +'/reset-password' }
}
